export const isRoleAdmin = role => role === 'admin' || role === 'super_admin';

export const isRoleOwner = role => role === 'owner';


export default {
  isRoleAdmin,
  isRoleOwner,
};
